/* eslint-disable no-dupe-keys */
export default {
  notification_record: {
    name: '订阅通知记录',
    // 属性（一般与对象内容匹配）
    prop: {
      notification_subscription: '通知订阅',
      admin: '接收的管理员',
      subject: '主题',
      mobile: '手机号',
      email: '邮箱',
      created_at: '发送时间',
      updated_at: '更新时间',
      // 非对象属性
      subscribed_item: '通知订阅',
      send_type: '通知方式'
    },
    // Enum的属性
    send_types: {
      send_by_email: '邮件',
      send_by_sms: '短信'
    },
    subscribed_items: {
      alarm: '告警通知',
      work_order: '工单处理',
      product: '商品购买'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询通知主题/手机号/邮箱',
      search_send_type: '查询通知方式'
    },
    // 详情页标签
    // 标签标题
    list_tabs: {
      all: '全部',
      alarm: '告警通知',
      work_order: '工单处理通知',
      product: '商品购买通知'
    }
    // 标题
  }
}
